import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/adminActions";
import { Actions as AUTHENTICATIONACTIONS } from "../../../store/actions/authenticationActions";
import { Actions as ADVISORACTIONS } from "../../../store/actions/advisorActions";

import { MagnifyingGlassIcon, UserCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { uniq } from "lodash";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "@/icons/outline";

const UserInfoModal = ({
	modalStatus,
	closeModal,
	getUserDetails,
	userInfo,
	switchAdvisor,
	advisors,
	organisations,
	getAdvisorList,
	switchCompany,
}) => {
	useEffect(() => {
		getAdvisorList();
	}, []);

	const Chip = ({ org, chipName, advisor }) => {
		return (
			<div
				style={{
					borderRadius: "4rem",
					background: "#ea611c",
					color: "white",
					textAlign: "center",
					cursor: "pointer",
					textOverflow: "ellipsis",
				}}
				onClick={() => {
					if (advisor) switchAdvisor(advisor);
					else switchCompany(org);
				}}
			>
				{chipName}
			</div>
		);
	};

	const [user, setUser] = useState("");
	const handleSubmit = (event) => {
		event.preventDefault();
		getUserDetails(user);
	};

	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">User Details</h3>
						</div>
						<form onSubmit={handleSubmit}>
							<div className="block-content">
								<div className="col-sm-12">
									<div className="col-sm-6">
										<div className="form-material">
											<label htmlFor="user">User</label>
											<input
												id="user"
												className="form-input form-control"
												onChange={(e) => setUser(e.target.value)}
												autoComplete="off"
											/>
										</div>
									</div>
									<button
										type="submit"
										className="pull-right btn btn-success"
									>
										<MagnifyingGlassIcon
											style={{ height: "1.5em", float: "left", marginRight: 5 }}
										/>
										<div style={{ float: "left" }}>Get User Information</div>
									</button>
								</div>
							</div>
						</form>

						{userInfo && (
							<>
								<div
									className="col-sm-12"
									style={{ padding: "4rem", paddingBottom: 0 }}
								>
									<div className="col-sm-3">
										<UserCircleIcon style={{ color: "grey", height: "10rem" }} />
									</div>
									<div className="col-sm-9">
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="userId">ID</label>
											<input
												id="userId"
												className="form-input form-control"
												value={userInfo?.id}
												disabled
											/>
										</div>
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="email">Email</label>
											<input
												id="email"
												className="form-input form-control"
												value={userInfo?.email}
												disabled
											/>
										</div>
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="name">Name</label>
											<input
												id="name"
												className="form-input form-control"
												value={userInfo?.givenName || userInfo?.name}
												disabled
											/>
										</div>
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="surname">Surname</label>
											<input
												id="surname"
												className="form-input form-control"
												value={userInfo?.familyName || userInfo?.surname}
												disabled
											/>
										</div>
									</div>
								</div>
								<div className="clearfix"></div>
								{userInfo?.organisations?.length > 0 && (
									<div className="col-xs-12">
										<h5>Administrator for</h5>
										<div
											className="grid gap-8 grid-cols-3"
											style={{ padding: "2rem" }}
										>
											{uniq(userInfo?.organisations || [])?.map((org) => {
												const companyName =
													organisations?.find((item) => item.id == org)?.name ||
													"Demo Company";
												return <Chip {...{ org, chipName: companyName }} />;
											})}
										</div>
									</div>
								)}
								{userInfo?.advisors?.length > 0 && (
									<div className="col-xs-12">
										<h5>Advisor at</h5>
										<div
											className="grid gap-8 grid-cols-3"
											style={{ padding: "2rem" }}
										>
											{uniq(userInfo?.advisors || [])?.map((advisor) => {
												const advisorName = advisors?.find((item) => item.id == advisor)?.name;
												return <Chip {...{ advisor, chipName: advisorName }} />;
											})}
										</div>
									</div>
								)}
								{userInfo?.employedOrganisations?.length > 0 && (
									<div className="col-xs-12">
										<h5>Employed under</h5>
										<div
											className="grid gap-8 grid-cols-3"
											style={{ padding: "2rem" }}
										>
											{uniq(userInfo?.employedOrganisations || [])?.map((org) => {
												const companyName =
													organisations?.find((item) => item.id == org)?.name ||
													"Demo Company";
												return <Chip {...{ org, chipName: companyName }} />;
											})}
										</div>
									</div>
								)}
								{userInfo?.activeCampaign && (
									<div className="col-xs-12">
										<h5>Links</h5>
										<div
											style={{ padding: "2rem" }}
										>
											<Link
												to={userInfo?.activeCampaign}
												target="_blank"
												className="btn btn-primary"
											>
												ActiveCampaign <ArrowUpRightIcon style={{ height: "1.5rem", paddingTop: "0.25rem" }} />
											</Link>
										</div>
									</div>
								)}
							</>
						)}
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const userInfo = state.admin?.getUser || {};
	const organisations = [
		userInfo?.isEmployee ? "Employee" : undefined,
		userInfo.isAdvisor ? "Advisor" : undefined,
		...(Array.isArray(userInfo.organisations) ? userInfo.organisations : []),
	]?.filter((item) => !!item);

	return {
		modalStatus: state.admin?.getUserModal,
		organisations: state?.admin?.organisations || [],
		advisors: state?.advisors?.advisorList || [],
		userInfo: { ...userInfo, organisations },
	};
};
const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.getUserModal()),
	switchCompany: (id) => dispatch(AUTHENTICATIONACTIONS.switchCompany(id)),
	switchAdvisor: (advisor) => dispatch(ADVISORACTIONS.switchAdvisor(advisor)),
	getAdvisorList: () => dispatch(ADVISORACTIONS.getAdvisorList()),
	getUserDetails: (user) => dispatch(ACTIONS.adminGetUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserInfoModal);
